import apiClient from '../helpers/ApiClient'
import {handleError, authHeader} from '../helpers/ApiClient';

export const aiDebuggerService = {
    getInvestigations,
    createInvestigation
}

function getInvestigations() {
    return apiClient.get("/ai-debugger/investigations", {headers: authHeader()})
        .then((response) => response.data)
        .catch((error) => handleError(error));
}

function createInvestigation(request) {
    return apiClient.post("/ai-debugger/investigations", request, {headers: authHeader()})
        .then((response) => response.data)
        .catch((error) => handleError(error));
}
